var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ClientSapCard',{attrs:{"client":_vm.client}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }